import { ReactNode } from 'react'

import { FormProvider, useForm } from 'react-hook-form'

import { IMultipleAutocompleteOption } from 'components/common/controller-wrapper'
import { TimePeriod } from 'components/reports/Metrics/constants'
import { VehicleTypeFilter } from 'generated/graphql'

export interface BidAnalysisFilterValues {
  period: TimePeriod
  customStart: Date | null
  customEnd: Date | null
  selectedServiceCodes: IMultipleAutocompleteOption[]
  vehicleType: VehicleTypeFilter
}

export const BID_ANALYSIS_DEFAULT_FILTERS: BidAnalysisFilterValues = {
  period: 'last30',
  customStart: null,
  customEnd: null,
  selectedServiceCodes: [],
  vehicleType: VehicleTypeFilter.All,
}

interface IProps {
  children: ReactNode
}

export const BidAnalysisFilterCriteria = ({ children }: IProps) => {
  const methods = useForm<BidAnalysisFilterValues>({
    defaultValues: BID_ANALYSIS_DEFAULT_FILTERS,
  })

  return <FormProvider {...methods}>{children}</FormProvider>
}
